import { useEffect, useState } from 'react';

const API = (process.env.REACT_APP_API_URL || 'http://localhost:8000') + '/api/personel';
const token = () => localStorage.getItem('token');
const hdr = () => ({ 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` });

const para = (v: number) => v?.toLocaleString('tr-TR', { minimumFractionDigits: 2 }) + ' ₺';

const BOŞ_MAAS = {
  personel_id: '', donem: new Date().toISOString().slice(0, 7),
  maas_tarihi: '',
  temel_maas: 0, ek_odeme: 0, ikramiye: 0, fazla_mesai: 0, diger_odeme: 0,
  sgk_primi: 0, gelir_vergisi: 0, damga_vergisi: 0, diger_kesinti: 0,
  aciklama: '',
};

export default function PersonelMaas() {
  const [liste, setListe] = useState<any[]>([]);
  const [personeller, setPersoneller] = useState<any[]>([]);
  const [form, setForm] = useState<any>(null);
  const [secilenPersonel, setSecilenPersonel] = useState<string>('');
  const [secilenDonem, setSecilenDonem] = useState<string>('');
  const [ozet, setOzet] = useState<any>(null);

  useEffect(() => {
    yukle();
    fetch(`${API}/?durum=aktif`, { headers: hdr() }).then(r => r.json()).then(setPersoneller);
  }, []);

  function yukle(pid = secilenPersonel, donem = secilenDonem) {
    const p = new URLSearchParams();
    if (pid)   p.set('personel_id', pid);
    if (donem) p.set('donem', donem);
    fetch(`${API}/maas/liste?${p}`, { headers: hdr() }).then(r => r.json()).then(setListe);
    if (pid) fetch(`${API}/maas/ozet/${pid}`, { headers: hdr() }).then(r => r.json()).then(d => {
      const toplam = d.length;
      const avgNet = toplam > 0 ? d.reduce((s: number, m: any) => s + m.net_maas, 0) / toplam : 0;
      const avgBrut = toplam > 0 ? d.reduce((s: number, m: any) => s + m.brut_toplam, 0) / toplam : 0;
      setOzet({ toplam, avgNet, avgBrut, son12: d });
    });
    else setOzet(null);
  }

  function personelDegistir(pid: string) {
    setSecilenPersonel(pid);
    yukle(pid, secilenDonem);
  }

  async function kaydet() {
    if (!form.personel_id) return alert('Personel seçiniz');
    if (!form.donem) return alert('Dönem giriniz (YYYY-MM)');
    const method = form.id ? 'PUT' : 'POST';
    const url = form.id ? `${API}/maas/${form.id}` : `${API}/maas`;
    const veri = { ...form, personel_id: Number(form.personel_id) };
    const sayisallar = ['temel_maas', 'ek_odeme', 'ikramiye', 'fazla_mesai', 'diger_odeme', 'sgk_primi', 'gelir_vergisi', 'damga_vergisi', 'diger_kesinti'];
    sayisallar.forEach(k => { veri[k] = Number(veri[k]) || 0; });
    await fetch(url, { method, headers: hdr(), body: JSON.stringify(veri) });
    setForm(null);
    yukle();
  }

  // Canlı hesap
  const brut = form ? (Number(form.temel_maas) + Number(form.ek_odeme) + Number(form.ikramiye) + Number(form.fazla_mesai) + Number(form.diger_odeme)) : 0;
  const kesinti = form ? (Number(form.sgk_primi) + Number(form.gelir_vergisi) + Number(form.damga_vergisi) + Number(form.diger_kesinti)) : 0;
  const net = brut - kesinti;

  // Dönem listesi
  const donemler = Array.from(new Set(liste.map(m => m.donem))).sort((a, b) => b.localeCompare(a));

  return (
    <div style={{ padding: 24, fontFamily: 'system-ui, sans-serif' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div>
          <h2 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: '#111827' }}>Özlük & Maaş Özeti</h2>
          <p style={{ margin: '4px 0 0', fontSize: 13, color: '#6b7280' }}>Temel maaş · Ek ödeme (375 KHK) · İkramiye · SGK · Gelir Vergisi</p>
        </div>
        <button onClick={() => setForm({ ...BOŞ_MAAS, personel_id: secilenPersonel })} style={{
          background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: 8,
          padding: '10px 20px', cursor: 'pointer', fontWeight: 600, fontSize: 14,
        }}>+ Maaş Girişi</button>
      </div>

      {/* FİLTRELER */}
      <div style={{ display: 'flex', gap: 10, marginBottom: 16 }}>
        <select value={secilenPersonel} onChange={e => personelDegistir(e.target.value)} style={{ ...selectSt, maxWidth: 280 }}>
          <option value="">Tüm Personel</option>
          {personeller.map(p => <option key={p.id} value={p.id}>{p.ad} {p.soyad} ({p.sicil_no})</option>)}
        </select>
        <input type="month" value={secilenDonem} onChange={e => { setSecilenDonem(e.target.value); yukle(secilenPersonel, e.target.value); }} style={inputSt} />
        {secilenDonem && <button onClick={() => { setSecilenDonem(''); yukle(secilenPersonel, ''); }} style={{ ...kücükBtnSt, padding: '6px 12px' }}>✕ Dönem Temizle</button>}
      </div>

      {/* PERSONEL ÖZET PANEL */}
      {ozet && (
        <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #bfdbfe', padding: 20, marginBottom: 20 }}>
          <div style={{ fontWeight: 700, fontSize: 14, color: '#1d4ed8', marginBottom: 14 }}>
            {personeller.find(p => p.id === Number(secilenPersonel))?.ad} {personeller.find(p => p.id === Number(secilenPersonel))?.soyad} — Son 12 Ay Özeti
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12, marginBottom: 16 }}>
            <div style={{ background: '#eff6ff', borderRadius: 8, padding: '10px 14px' }}>
              <div style={{ fontSize: 11, color: '#6b7280' }}>Kayıt Sayısı</div>
              <div style={{ fontSize: 22, fontWeight: 700, color: '#1d4ed8' }}>{ozet.toplam}</div>
            </div>
            <div style={{ background: '#ecfdf5', borderRadius: 8, padding: '10px 14px' }}>
              <div style={{ fontSize: 11, color: '#6b7280' }}>Ort. Net Maaş</div>
              <div style={{ fontSize: 18, fontWeight: 700, color: '#065f46' }}>{para(ozet.avgNet)}</div>
            </div>
            <div style={{ background: '#fef3c7', borderRadius: 8, padding: '10px 14px' }}>
              <div style={{ fontSize: 11, color: '#6b7280' }}>Ort. Brüt Maaş</div>
              <div style={{ fontSize: 18, fontWeight: 700, color: '#92400e' }}>{para(ozet.avgBrut)}</div>
            </div>
          </div>
          {/* Mini tablo son 12 ay */}
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
              <thead>
                <tr style={{ borderBottom: '1px solid #e5e7eb' }}>
                  {['Dönem', 'Brüt', 'Kesinti', 'Net'].map(h => (
                    <th key={h} style={{ padding: '6px 10px', textAlign: 'right', fontWeight: 600, color: '#374151', fontSize: 11 }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {ozet.son12.map((m: any) => (
                  <tr key={m.id} style={{ borderBottom: '1px solid #f3f4f6' }}>
                    <td style={{ padding: '5px 10px', fontFamily: 'monospace', textAlign: 'right' }}>{m.donem}</td>
                    <td style={{ padding: '5px 10px', textAlign: 'right', color: '#92400e' }}>{para(m.brut_toplam)}</td>
                    <td style={{ padding: '5px 10px', textAlign: 'right', color: '#991b1b' }}>–{para(m.toplam_kesinti)}</td>
                    <td style={{ padding: '5px 10px', textAlign: 'right', color: '#065f46', fontWeight: 700 }}>{para(m.net_maas)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* ANA LİSTE */}
      <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e5e7eb', overflow: 'hidden' }}>
        {liste.length === 0 ? (
          <div style={{ padding: 40, textAlign: 'center', color: '#9ca3af' }}>Maaş kaydı bulunamadı.</div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ background: '#f9fafb', borderBottom: '1px solid #e5e7eb' }}>
                {['Personel', 'Dönem', 'Temel Maaş', 'Ek Ödeme', 'İkramiye', 'Fazla Mesai', 'BRÜT', 'SGK', 'GV', 'DV', 'NET', ''].map(h => (
                  <th key={h} style={{ padding: '9px 10px', textAlign: 'right', fontWeight: 600, color: '#374151', fontSize: 11, whiteSpace: 'nowrap' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {liste.map((m, i) => (
                <tr key={m.id} style={{ borderBottom: '1px solid #f3f4f6', background: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                  <td style={{ padding: '8px 10px', fontWeight: 600, textAlign: 'left' }}>{m.personel_adi || `#${m.personel_id}`}</td>
                  <td style={{ padding: '8px 10px', fontFamily: 'monospace', textAlign: 'right', color: '#1d4ed8', fontWeight: 700 }}>{m.donem}</td>
                  <td style={{ padding: '8px 10px', textAlign: 'right', fontSize: 12 }}>{para(m.temel_maas)}</td>
                  <td style={{ padding: '8px 10px', textAlign: 'right', fontSize: 12 }}>{para(m.ek_odeme)}</td>
                  <td style={{ padding: '8px 10px', textAlign: 'right', fontSize: 12 }}>{para(m.ikramiye)}</td>
                  <td style={{ padding: '8px 10px', textAlign: 'right', fontSize: 12 }}>{para(m.fazla_mesai)}</td>
                  <td style={{ padding: '8px 10px', textAlign: 'right', fontWeight: 700, color: '#92400e' }}>{para(m.brut_toplam)}</td>
                  <td style={{ padding: '8px 10px', textAlign: 'right', fontSize: 12, color: '#991b1b' }}>–{para(m.sgk_primi)}</td>
                  <td style={{ padding: '8px 10px', textAlign: 'right', fontSize: 12, color: '#991b1b' }}>–{para(m.gelir_vergisi)}</td>
                  <td style={{ padding: '8px 10px', textAlign: 'right', fontSize: 12, color: '#991b1b' }}>–{para(m.damga_vergisi)}</td>
                  <td style={{ padding: '8px 10px', textAlign: 'right', fontWeight: 800, color: '#065f46', fontSize: 14 }}>{para(m.net_maas)}</td>
                  <td style={{ padding: '8px 10px' }}>
                    <button onClick={() => setForm({ ...m })} style={kücükBtnSt}>Düzenle</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* FORM MODALI */}
      {form && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: '#fff', borderRadius: 14, padding: 28, width: 660, maxHeight: '92vh', overflow: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <h3 style={{ margin: 0, fontSize: 18, fontWeight: 700 }}>Maaş Kaydı</h3>
              <button onClick={() => setForm(null)} style={{ background: 'none', border: 'none', fontSize: 18, cursor: 'pointer', color: '#9ca3af' }}>✕</button>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
              <Alan etiket="Personel *" tam>
                <select value={form.personel_id} onChange={e => setForm({ ...form, personel_id: e.target.value })} style={selectSt}>
                  <option value="">Seçiniz</option>
                  {personeller.map(p => <option key={p.id} value={p.id}>{p.ad} {p.soyad} ({p.sicil_no})</option>)}
                </select>
              </Alan>
              <Alan etiket="Dönem (YYYY-MM) *">
                <input type="month" value={form.donem} onChange={e => setForm({ ...form, donem: e.target.value })} style={inputSt} />
              </Alan>
              <Alan etiket="Maaş Ödeme Tarihi">
                <input type="date" value={form.maas_tarihi} onChange={e => setForm({ ...form, maas_tarihi: e.target.value })} style={inputSt} />
              </Alan>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0 }}>
              {/* ÖDEMELER */}
              <div style={{ background: '#f0fdf4', borderRadius: '10px 0 0 10px', padding: 16, border: '1px solid #86efac' }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#065f46', marginBottom: 12 }}>ÖDEMELER</div>
                {[
                  { key: 'temel_maas', label: 'Temel Maaş' },
                  { key: 'ek_odeme',   label: 'Ek Ödeme (375 KHK)' },
                  { key: 'ikramiye',   label: 'İkramiye' },
                  { key: 'fazla_mesai', label: 'Fazla Mesai' },
                  { key: 'diger_odeme', label: 'Diğer Ödeme' },
                ].map(f => (
                  <div key={f.key} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                    <label style={{ fontSize: 12, color: '#374151' }}>{f.label}</label>
                    <input type="number" min={0} step={0.01} value={form[f.key]} onChange={e => setForm({ ...form, [f.key]: e.target.value })}
                      style={{ ...inputSt, width: 130, textAlign: 'right', padding: '4px 8px' }} />
                  </div>
                ))}
                <div style={{ borderTop: '2px solid #86efac', paddingTop: 8, display: 'flex', justifyContent: 'space-between', fontWeight: 700 }}>
                  <span style={{ color: '#065f46' }}>BRÜT TOPLAM</span>
                  <span style={{ color: '#065f46', fontSize: 15 }}>{para(brut)}</span>
                </div>
              </div>

              {/* KESİNTİLER */}
              <div style={{ background: '#fef2f2', borderRadius: '0 10px 10px 0', padding: 16, border: '1px solid #fecaca', borderLeft: 'none' }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#991b1b', marginBottom: 12 }}>KESİNTİLER</div>
                {[
                  { key: 'sgk_primi',     label: 'SGK Primi (%14)' },
                  { key: 'gelir_vergisi', label: 'Gelir Vergisi' },
                  { key: 'damga_vergisi', label: 'Damga Vergisi' },
                  { key: 'diger_kesinti', label: 'Diğer Kesinti' },
                ].map(f => (
                  <div key={f.key} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                    <label style={{ fontSize: 12, color: '#374151' }}>{f.label}</label>
                    <input type="number" min={0} step={0.01} value={form[f.key]} onChange={e => setForm({ ...form, [f.key]: e.target.value })}
                      style={{ ...inputSt, width: 130, textAlign: 'right', padding: '4px 8px' }} />
                  </div>
                ))}
                <div style={{ borderTop: '2px solid #fecaca', paddingTop: 8, display: 'flex', justifyContent: 'space-between', fontWeight: 700 }}>
                  <span style={{ color: '#991b1b' }}>TOPLAM KESİNTİ</span>
                  <span style={{ color: '#991b1b', fontSize: 15 }}>–{para(kesinti)}</span>
                </div>
              </div>
            </div>

            {/* NET MAAŞ */}
            <div style={{ background: '#eff6ff', borderRadius: 10, padding: '14px 20px', marginTop: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center', border: '2px solid #bfdbfe' }}>
              <span style={{ fontWeight: 700, fontSize: 16, color: '#1d4ed8' }}>NET MAAŞ</span>
              <span style={{ fontWeight: 800, fontSize: 24, color: '#1d4ed8' }}>{para(net)}</span>
            </div>

            <div style={{ marginTop: 12 }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Açıklama</label>
              <textarea value={form.aciklama} onChange={e => setForm({ ...form, aciklama: e.target.value })} style={{ ...inputSt, height: 50, resize: 'vertical' }} />
            </div>

            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 20 }}>
              <button onClick={() => setForm(null)} style={{ padding: '9px 20px', border: '1px solid #d1d5db', borderRadius: 8, background: '#f3f4f6', color: '#374151', cursor: 'pointer', fontWeight: 600 }}>İptal</button>
              <button onClick={kaydet} style={{ padding: '9px 20px', border: 'none', borderRadius: 8, background: '#1d4ed8', color: '#fff', cursor: 'pointer', fontWeight: 600 }}>Kaydet</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function Alan({ etiket, tam, children }: { etiket: string; tam?: boolean; children: React.ReactNode }) {
  return (
    <div style={{ gridColumn: tam ? '1 / -1' : undefined }}>
      <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>{etiket}</label>
      {children}
    </div>
  );
}

const inputSt: React.CSSProperties = { width: '100%', padding: '7px 10px', border: '1px solid #d1d5db', borderRadius: 7, fontSize: 13, boxSizing: 'border-box' };
const selectSt: React.CSSProperties = { ...inputSt, background: '#fff' };
const kücükBtnSt: React.CSSProperties = { background: 'none', border: '1px solid #d1d5db', borderRadius: 6, padding: '3px 10px', cursor: 'pointer', fontSize: 12, color: '#374151' };
